import { useLocation, useNavigate } from "react-router-dom";
import { useGetTiCardData } from "../../../../search/components/ticard/hooks";

import { useLocalSampleSummaryParams } from "../../../hooks";
import { pathToSS } from "../../../util";
import { THREAT_INTELLIGENCE_CARD_ID } from "../../report_summary/cards/threat_intelligence/ThreatIntelligenceCard";

import { settings } from "../../../../../shim/jsbridge";
import ThreatInfo from "./ThreatInfo";

const { FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE } = settings ?? {};

type Props = {
  name: string;
};

const ThreatInfoCard = ({ name }: Props) => {
  const { hash, sourceId } = useLocalSampleSummaryParams();
  const { search } = useLocation();
  const { data } = useGetTiCardData(name);
  const navigate = useNavigate();

  const handleSectionClick = () => {
    if (!name) return;
    if (!FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE) return;
    const path = pathToSS(hash, sourceId, "");
    navigate(`${path}${search}#${THREAT_INTELLIGENCE_CARD_ID}`);
  };

  const actors = data?.rl?.general?.actor?.map(item => item.name);

  return (
    <ThreatInfo
      actors={actors ?? []}
      name={name}
      className={
        Boolean(name) &&
        FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE &&
        "cursor-pointer"
      }
      onClick={handleSectionClick}
    />
  );
};

export default ThreatInfoCard;
